import type { MountDeckPlayerWidgetHandle, MountDeckPlayerWidgetOptions } from '../integration'
import { mountDeckPlayerWidget } from '../integration'
import { DeckPlayerWidgetButton } from '../widgets/components'

const DISPLAY_NAME = 'deckplayer-button'
const DEFAULT_SELECTOR = '[data-deckplayer-widget^="deckplayer-btn-"]'

export function mountDeckPlayerButtonWidget(
  target: string | Element = DEFAULT_SELECTOR,
  opts: Omit<MountDeckPlayerWidgetOptions, 'displayName'> = {},
): Promise<MountDeckPlayerWidgetHandle> {
  return mountDeckPlayerWidget(target, DeckPlayerWidgetButton, {
    ...opts,
    displayName: DISPLAY_NAME,
  })
}
